'use client';

import React from 'react';

import { URLS } from '@/constants';
import { USE_ANCAP_UPLIFT } from '@/constants/flags';
import { Link } from '@/components/link';
import Navigation from '@/components/navigation';
import CompareCars, { type CompareCarsProps } from '@/components/compare-cars';
import CompareButton from '@/components/compare-button';
import { type SocialLinksProps } from '@/components/social-links';
import { cn } from '@/lib/utils';
import TacLogo from '@/assets/logos/tac-logo.svg';
import Image from 'next/image';
import HowSafeIsYourCarHeading from '@/components/how-safe-is-your-car-heading';
import { type DrawerNavLinksProps } from '@/components/navigation/components/drawer-nav-links';

type HeaderProps = {
  primaryNavProps: DrawerNavLinksProps;
  secondaryNavProps?: DrawerNavLinksProps;
  socialLinksProps: SocialLinksProps;
  compareButtonProps?: CompareCarsProps['compareButtonProps'];
};

const Header = ({
  primaryNavProps,
  secondaryNavProps = { links: [] },
  socialLinksProps = { socialIcons: [], tagline: '' },
  compareButtonProps,
}: HeaderProps) => {
  return (
    <header
      className={cn('relative h-16 lg:h-20 z-[3] bg-white px-4 lg:px-12 flex items-center justify-between gap-2')}
    >
      <Navigation
        primaryNavProps={primaryNavProps}
        secondaryNavProps={secondaryNavProps}
        socialLinksProps={socialLinksProps}
      />
      <Link
        href={URLS.HOME}
        tracking={{
          event: 'navigation_click',
          navigation_type: 'main_nav',
          click_text: 'TAC',
          nav_level: '1',
        }}
        className={cn(
          'order-2 flex justify-center gap-6 md:order-1 md:static md:flex-initial md:justify-start',
          'absolute left-1/2 -translate-x-1/2 md:static md:left-auto md:translate-x-0'
        )}
      >
        <HowSafeIsYourCarHeading className="hidden lg:block" />
        <Image src={TacLogo} alt="TAC Logo" height={28} className="max-h-7" />
      </Link>
      <div className="order-3">
        {USE_ANCAP_UPLIFT ? (
          <CompareButton />
        ) : (
          compareButtonProps && <CompareCars compareButtonProps={compareButtonProps} />
        )}
      </div>
    </header>
  );
};

export default Header;
